var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10302",
    "data-name": "Group 10302",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    transform: "translate(321 1888)",
    fill: "#fff",
    stroke: "#4a13b2",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_card",
    "data-name": "vuesax/linear/card",
    transform: "translate(335.597 1902.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H22.338",
    transform: "translate(2.234 9.499)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H2.234",
    transform: "translate(6.701 18.434)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H4.468",
    transform: "translate(11.727 18.434)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.959,0H17.368c3.976,0,4.97.983,4.97,4.9v9.17c0,3.92-.994,4.9-4.959,4.9H4.959C.994,18.987,0,18,0,14.084V4.9C0,.983.994,0,4.959,0Z",
    transform: "translate(2.234 3.915)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H26.805V26.805H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.dde7415c444c880578e6715bb572633c.svg";
export { ForwardRef as ReactComponent };